<div class="app-content content container-fluid left">
  <div class="content-wrapper">
    <div class="content-body">
      <ngb-alert type="warning" [dismissible]="false" *ngIf="service_type === 'TDLTE'">
        <strong>{{'WARNING' | translate}}: </strong>{{'TDLTE_DAYS_TO_EOF_MONTH' | translate}}
      </ngb-alert>
      <ngb-tabset [justify]="'center'">
        <ng-container *ngFor="let group_service of services">
          <ngb-tab id="{{group_service.group_name}}">
            <ng-template ngbTabTitle>
              <h4 class="p-2">
                {{ group_service.group_name | translate }}
              </h4>
            </ng-template>
            <ng-template ngbTabContent>
              <div class="row" *ngIf="service_type !== 'TDLTE'">
                <div class="col-lg-6 col-md-12 col-sm-12" *ngFor="let service of group_service.services">
                  <div class="card">
                    <div class="card-header">
                      <div class="row">
                        <div style="margin: 0 auto;">
                          <h2 *ngIf="service.bps === service.mbps || !service.mbps" class="card-title">{{
                            service.service_name | translate }}: {{'SPEED' | translate}} {{ (service.bps |
                            bytes:0:'B':'en').toLowerCase().replace(' ','')}}</h2>
                          <h2 *ngIf="service.bps !== service.mbps && service.mbps" class="card-title">{{
                            service.service_name | translate }}: {{'SPEED' | translate}} {{ (service.mbps |
                            bytes:0:'B':'en').toLowerCase().replace(' ','')}} ~ {{ (service.bps |
                            bytes:0:'B':'en').toLowerCase().replace(' ','')}}</h2>
                        </div>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="card-block">
                        <!-- <table class="table" *ngIf="service.rules">
                            <thead>
                              <tr>
                                <th class="text-center" rowspan="2">{{ 'FROM' | translate }}</th>
                                <th class="text-center" rowspan="2">{{ 'TO' | translate }}</th>
                                <th class="text-center" rowspan="2">{{ 'BANDWIDTH' | translate }}</th>
                                <th class="text-center"
                                  *ngIf="service.hasDownDisc+service.hasUpDisc+service.hasIntDisc+service.hasSocDisc"
                                  [attr.colspan]="service.hasDownDisc+service.hasUpDisc+service.hasIntDisc+service.hasSocDisc">
                                  {{ 'DISCOUNT' | translate}}</th>
                                <th class="text-center" rowspan="2" *ngIf="service.hasPenalty">
                                  {{ 'EXTERNAL_PENALTY' | translate}}</th>
                              </tr>
                              <tr>
                                <th class="text-center" *ngIf="service.hasDownDisc">{{ 'DOWNLOAD_DISCOUNT' | translate }}
                                </th>
                                <th class="text-center" *ngIf="service.hasUpDisc">{{ 'UPLOAD_DISCOUNT' | translate }}</th>
                                <th class="text-center" *ngIf="service.hasIntDisc">{{ 'INTERNAL_DISCOUNT' | translate}}
                                </th>
                                <th class="text-center" *ngIf="service.hasSocDisc">{{ 'SOCIAL_DISCOUNT' | translate}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let rule of service.rules | sort: 'time_end'">
                                <td class="text-center">{{ rule.time_start }}</td>
                                <td class="text-center">{{ rule.time_end }}</td>
                                <td class="text-center">{{ rule.bandwidth }}</td>
                                <td class="text-center" *ngIf="service.hasDownDisc">{{ rule.input_discount*100 }}%</td>
                                <td class="text-center" *ngIf="service.hasUpDisc">{{ rule.output_discount*100 }}%</td>
                                <td class="text-center" *ngIf="service.hasIntDisc">{{ rule.internal_discount*100 }}%</td>
                                <td class="text-center" *ngIf="service.hasSocDisc">{{ rule.social_discount*100 }}%</td>
                                <td class="text-center" *ngIf="service.hasPenalty">{{ rule.external_penalty*100 }}%</td>
                              </tr>
                            </tbody>
                          </table> -->
                        <div class="row">
                          <div class="col-md-6 col-sm-6 col-sm-12" *ngFor="let price of service.prices">
                            <div class="card">
                              <h2 class="card-header text-center"
                                [ngClass]="{'bg-gray-100': price.length === 1,'bg-gray-200': price.length === 3,'bg-gray-300': price.length === 6,'bg-gray-400': price.length === 12}">
                                {{price.length_text | translate}}
                              </h2>

                              <div class="card-body text-center">
                                <h2 *ngIf="price.traffic">
                                  {{ price.traffic | bytes }}
                                </h2>
                                <h4 *ngIf="price.traffic && price.is_fup">
                                  {{ 'EQUALS' | translate }} {{ price.traffic / 2 | bytes }}
                                  {{ 'INTERNATIONAL' | translate }}
                                </h4>
                                <h2 *ngIf="!price.traffic">
                                  {{ 'UNLIMITED' | translate }}
                                </h2>
                                <h4 *ngIf="price.fair_usage">
                                  {{ 'FAIR_USAGE' | translate }} {{ price.fair_usage | bytes }}
                                </h4>
                                <a class="btn btn-primary text-white" (click)="priceChoosed(price)">
                                  <h5 class="mb-0">
                                    <i *ngIf="service.self_service" class="fa fa-shopping-basket"></i>
                                    <i *ngIf="!service.self_service" class="fa fa-phone"></i>
                                    {{price.price | money: translator.getDefaultLang() }}
                                  </h5>
                                </a>
                                <a *ngIf="price.cra_id"
                                  href="https://etebar-basteh.cra.ir/?OperatorId=72&PackCode={{price.cra_id}}"
                                  target="{{price.cra_id}}">{{'CRA_VALIDATION' | translate}}</a>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="service_type === 'TDLTE'">
                <div class="row" *ngFor="let service of group_service.services">
                  <div class="col-lg-6 col-md-12 col-sm-12" *ngFor="let l of service_length_shared">
                    <div class="card">
                      <div class="card-header">
                        <div class="row">
                          <div style="margin: 0 auto;">
                            <h2 class="card-title">{{ l.name | translate }}</h2>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="card-block">
                          <table class="w-100 table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>{{'NAME' | translate}}</th>
                                <th>{{'TRAFFIC' | translate}}</th>
                                <th>{{'PRICE' | translate}}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let price of service.prices | filter: 'length': l.value">
                                <td>{{price.name}}</td>
                                <td *ngIf="price.traffic">{{price.traffic | bytes}}</td>
                                <td *ngIf="!price.traffic">{{ 'UNLIMITED' | translate}}</td>
                                <td> <a class="btn btn-primary text-white" (click)="priceChoosed(price)">
                                    <h5 class="mb-0">
                                      <i *ngIf="service.self_service" class="fa fa-shopping-basket"></i>
                                      <i *ngIf="!service.self_service" class="fa fa-phone"></i>
                                      {{price.price | money: translator.getDefaultLang() }}
                                    </h5>
                                  </a>
                                  <a *ngIf="price.cra_id"
                                    href="https://etebar-basteh.cra.ir/?OperatorId=72&PackCode={{price.cra_id}}"
                                    target="{{price.cra_id}}">{{'CRA_VALIDATION' | translate}}</a>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ng-container>
      </ngb-tabset>
    </div>
  </div>
</div>